"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspendedAmountServiceStub = void 0;
const stubSettlement = {
    _id: "settlements-1",
    shareholderId: "shareholders-1",
    paymentDate: new Date("2026-06-01"),
    totalCents: 50000,
    settledDistributions: [
        {
            distributionId: "distributions-1",
            name: "Q1 2026 income distribution",
            periodPaidFrom: new Date("2026-01-01"),
            periodPaidTo: new Date("2026-03-31"),
            grossCents: 50000,
            netCents: 50000,
            taxWithheldCents: 0,
        },
    ],
    clearedBy: "users-1",
    createdAt: new Date("2026-06-01"),
};
class SuspendedAmountServiceStub {
    async getSuspendedAmounts(_companyId, _shareholderId) {
        return {
            status: true,
            message: "ok",
            payload: {
                outstandingCents: 50000,
                clearable: true,
                balances: [
                    {
                        distributionId: "distributions-1",
                        name: "Q1 2026 income distribution",
                        periodPaidFrom: new Date("2026-01-01"),
                        periodPaidTo: new Date("2026-03-31"),
                        netCents: 50000,
                        taxWithheldCents: 0,
                        unpaidReason: "not_on_register",
                        claimed: false,
                    },
                ],
            },
        };
    }
    async clearSuspendedAmounts(_companyId, _shareholderId, _paymentDate) {
        return { status: true, message: "ok", payload: { settlement: stubSettlement, outstandingCents: 0 } };
    }
    async getSuspendedSettlements(_companyId, _shareholderId) {
        return { status: true, message: "ok", payload: [stubSettlement] };
    }
    async getSuspendedSettlementStatement(_companyId, _shareholderId, _settlementId) {
        return { status: true, message: "ok", payload: { fileName: "settlement-statement.pdf", content: "" } };
    }
    async getSuspendedSettlementAbaFile(_companyId, _shareholderId, _settlementId) {
        return { status: true, message: "ok", payload: { fileName: "suspended-settlement.aba", content: "" } };
    }
}
exports.SuspendedAmountServiceStub = SuspendedAmountServiceStub;
//# sourceMappingURL=SuspendedAmountServiceStub.js.map